interface Props {
  color?: string
  className?: string
}

export default function SpeedIcon({ color = '#CCFF00', className }: Props) {
  return (
    <svg
      width="11"
      height="16"
      viewBox="0 0 11 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.3125 5C9.875 5 10.25 5.65625 9.9375 6.125L4.4375 15.625C4.3125 15.875 4.0625 16 3.78125 16C3.3125 16 2.96875 15.5625 3.0625 15.0938L4.5 9H0.8125C0.34375 9 0 8.625 0.0625 8.15625L1.0625 0.65625C1.09375 0.28125 1.4375 0 1.8125 0H6.3125C6.78125 0 7.15625 0.46875 7.03125 0.96875L5.6875 5H9.3125Z"
        fill={color}
      />
    </svg>
  )
}
